import {Component, Element, Prop, Watch} from '@stencil/core';

@Component({
  tag: 'fading-image',
  styleUrl: 'fading-image.scss',
  shadow: false,
  assetsDirs: [],
})
export class FadingImage {

  @Prop()
  alt: string;

  @Prop()
  src: string;

  @Element()
  host: HTMLElement;

  currentImageElement: HTMLImageElement;

  prevImageElement: HTMLImageElement;

  currentSrc: string;
  prevSrc: string;

  componentWillLoad() {
    this.watchImageFading();
  }

  @Watch('src')
  watchImageFading() {
    this.prevSrc = this.currentSrc;
    this.prevImageElement = this.currentImageElement;
    this.currentSrc = this.src;

    this.currentImageElement = new Image();
    this.imageOnLoad();
    this.imageOnError();
    this.currentImageElement.src = this.currentSrc;
    this.currentImageElement.alt = this.alt;
    }

  private imageOnLoad() {
    this.currentImageElement.onload = () => {
        this.appendImage();
    }
  }

  private imageOnError() {
    this.currentImageElement.onerror = () => {
        this.appendImage();
    }
  }

  private appendImage() {
    this.host.append(this.currentImageElement);
    this.currentImageElement.classList.add('fade-in');
    setTimeout(() => {
      if (this.prevImageElement) {
        const imageToBeRemoved = this.prevImageElement;
        this.currentImageElement.classList.add('fade-in');
        this.prevImageElement.classList.add('fade-out');
        setTimeout(() => {
          imageToBeRemoved.remove();
        }, 2000);
      }
    }, 300);
  }
}


